var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7497 53.1663H36.2497C48.333 53.1663 53.1663 48.333 53.1663 36.2497V21.7497C53.1663 9.66634 48.333 4.83301 36.2497 4.83301H21.7497C9.66634 4.83301 4.83301 9.66634 4.83301 21.7497V36.2497C4.83301 48.333 9.66634 53.1663 21.7497 53.1663Z",
    stroke: "#8593A8",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7503 24.1667C24.4197 24.1667 26.5837 22.0027 26.5837 19.3333C26.5837 16.664 24.4197 14.5 21.7503 14.5C19.0809 14.5 16.917 16.664 16.917 19.3333C16.917 22.0027 19.0809 24.1667 21.7503 24.1667Z",
    stroke: "#8593A8",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45312 45.7953L18.3673 37.7961C20.2765 36.5153 23.0315 36.6603 24.7473 38.1344L25.5448 38.8353C27.4298 40.4544 30.4748 40.4544 32.3598 38.8353L42.4131 30.2078C44.2981 28.5886 47.3431 28.5886 49.2281 30.2078L53.1673 33.5911",
    stroke: "#8593A8",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.2171f2f2d1a9cb4d1e80465a65a685b1.svg";
export { ForwardRef as ReactComponent };